import { MsalProvider } from '@azure/msal-react';
import { Route } from 'react-router';

import { msalInstance } from '@/authConfig';
import { AppShell } from '@/components/layout/app-shell';
import { Providers } from '@/context/use-providers';
import DeliveryLogPage from '@/pages/delivery-log';
import DeliveryLogEntryPage from '@/pages/delivery-log/[id]';
import OverviewPage from '@/pages/overview';
import RetryProcessorPage from '@/pages/retry-processor';
import RetryProcessorDetailPage from '@/pages/retry-processor/[id]';
import SettingsPage from '@/pages/settings';
import WebhooksIndexPage from '@/pages/webhooks';
import WebhooksDetailPage from '@/pages/webhooks/[id]';

/**
 * App shell (task [3.1]) — mirrors Fireball.Ui/src/app.tsx: MsalProvider wraps
 * Providers, which owns the router/query/tooltip composition and threads these
 * <Route> children into its <Routes>. The four screens map 1:1 to email-hub's
 * fixed nav; the real screen bodies are built by tasks [3.2]-[3.5] behind their
 * placeholder default exports.
 *
 * The four screens are nested under a single <AppShell> layout route so the
 * sidebar-nav rail (resend.md § sidebarNav) persists across navigation and
 * renders each screen through its <Outlet/> instead of remounting per route.
 */
export default function App() {
	return (
		<MsalProvider instance={msalInstance}>
			<Providers>
				<Route element={<AppShell />}>
					<Route path="/" element={<OverviewPage />} />
					<Route path="/delivery-log" element={<DeliveryLogPage />} />
					<Route
						path="/delivery-log/:id"
						element={<DeliveryLogEntryPage />}
					/>
					<Route path="/settings" element={<SettingsPage />} />
					<Route path="/webhooks" element={<WebhooksIndexPage />} />
					<Route path="/webhooks/:id" element={<WebhooksDetailPage />} />
					<Route path="/retry-processor" element={<RetryProcessorPage />} />
					<Route
						path="/retry-processor/:id"
						element={<RetryProcessorDetailPage />}
					/>
				</Route>
			</Providers>
		</MsalProvider>
	);
}
